// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#create .v-speed-dial[data-v-53870486]{position:absolute}#create .v-btn--floating[data-v-53870486]{position:relative}.v-btn.micro-btn[data-v-53870486]{height:26px!important;width:26px!important;min-width:26px!important}.v-btn.micro-btn .v-icon[data-v-53870486]{font-size:16px!important}.v-btn.micro-btn i[data-v-53870486]{font-size:12px!important}", ""]);
// Exports
module.exports = exports;
